import { render } from "./Overview.vue?vue&type=template&id=5cf2c115&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=5cf2c115&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf2c115"],['__file',"src/scripts/view/review/components/Overview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5cf2c115"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5cf2c115', __exports__)) {
    api.reload('5cf2c115', __exports__)
  }
  
  module.hot.accept("./Overview.vue?vue&type=template&id=5cf2c115&scoped=true", () => {
    api.rerender('5cf2c115', render)
  })

}


export default __exports__